module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0101",
      "epub:type": "chapter",
      "id": "ch01",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0101"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "22",
      "epub:type": "pagebreak",
      "id": "p22",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0005#toc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Stacked Decks")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p22"
    }
  }), _vm._v("In card games, a stacked deck means that the chances of winning are not equal because players have uneven hands. Maybe someone has all the aces, or five consecutive spades. Depending on the game you are playing, either of these hands could guarantee you a win. Stacked decks can be a result of a dealer manipulating a pack of cards to ensure that someone gets a good hand. They can also occur when players have uneven chances to win—for example, if a professional poker player plays a novice. Not all stacked decks are zero-sum games in which the winner takes all. There are gradations of good and bad hands that up peoples’ chances of winning and losing. But whatever their gradation, these hands are relational, meaning that one is related to and dependent on another. In a game where all the cards are dealt, the strength of your hand determines the strength of someone else’s.")]), _vm._v(" "), _c('p', [_vm._v("Cities are stacked decks: vastly uneven places where extreme wealth and poverty go hand in hand. The following pages take us on a tour of one city—Chicago—and its disparate housing conditions. We travel through a landscape of vacant lots, foreclosed homes, and institutional neglect, before visiting streets of concentrated wealth. We see pockets of luxury and profit amid neighborhood poverty, and visit a community dealing with displacement and upscaling. The tour takes in some familiar historical and contemporary practices that have stacked the deck for some residents at the expense of others: from redlining and contract sales, to predatory lending, uneven development, property takings, financialization, evictions, and foreclosure. These actions have allowed wealth extraction, slumlordism, and displacement, which stockpile wealth and exacerbate poverty. Thanks to sociologists and historians, we already know a good amount about why areas of concentrated poverty look the way they do, and how "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "23",
      "epub:type": "pagebreak",
      "id": "p23",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the deck has been stacked against their residents. But we know much less about the underlying conditions that shape the look and feel of wealthier neighborhoods. Although wealth and poverty seem worlds apart, they are relational, meaning that some homes and neighborhoods are dilapidated because resources are channeled to and hoarded within others."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en52",
      "id": "en52r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" This chapter uses a tour of Chicago to explain the underlying relational reasons for disparities in housing conditions and in the issues that building inspectors face.")]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0101"
    }
  }, [_vm._v("The Geography of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Chicago’s geography exhibits stark disparity. Chicagoans divide their city rhetorically into the North, South, and West Sides, which are depicted in the map in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0008#fig1"
    }
  }, [_vm._v("figure 1")]), _vm._v(". Chicago’s sides are more than just names; they refer to and invoke huge differences in racial and class demographics. We can see this in the maps in figures "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0008#fig2"
    }
  }, [_vm._v("2")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0008#fig3"
    }
  }, [_vm._v("3")]), _vm._v(", which depict median household income and the White (non-Hispanic) population in Chicago, respectively."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en53",
      "id": "en53r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" The North Side houses most of the city’s White population, while the South and West Sides are (today) predominately Black. The North Side is also wealthier than the South and West Sides. The Northwest and Southwest Sides are more heterogeneous, with large Latinx populations. The labels Chicagoans use obscure heterogeneity, but by and large they denote segregation.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig1"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "24",
      "epub:type": "pagebreak",
      "id": "p24",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-bartram-fig001.jpeg",
      "width": "463"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FIGURE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.")])]), _vm._v(" Geography of Chicago. Map by Richard Campanella.")])])]), _vm._v(" "), _c('p', [_vm._v("Chicago is segregated by race, income, and wealth, and this means different parts of the city look different."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en54",
      "id": "en54r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])]), _vm._v(" The South and Southwest Sides have streets of empty lots and disrepair, while North Side housing stock is denser and is rarely allowed to decay. The “side” terminology is handy because it conveys critical material differences. It is especially useful for social scientists, many of whom deal in averages. The terminology is also meaningful; Chicagoans—on the North, South, and West Sides—use these words.")]), _vm._v(" "), _c('p', [_vm._v("But we should not forget that averages can conceal outliers, variation, and places that do not fit the mold. The general understanding of Chicago’s South Side as poor and neglected, for example, conceals the area’s rich architecture and culture and strong institutions, and the pride, joy, and durability of many South Siders and their communities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en55",
      "id": "en55r",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])]), _vm._v(" It also obscures the fact that, as Mary Pattillo has made clear, there are middle-class and upper-middle-class Black people living in Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en56",
      "id": "en56r",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p24"
    }
  }), _vm._v("Similarly, labeling the North Side as wealthy can ignore the slum-like conditions in some North Side apartments. Moreover, referring to Chicago in terms of sides can reify them, and this can be stigmatizing. The ease with which we make these distinctions can also mean we forget that segregation is not natural or inevitable. As Natalie Moore points out, segregation is such a well-known characteristic of Chicago that we often "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "25",
      "epub:type": "pagebreak",
      "id": "p25",
      "role": "doc-pagebreak"
    }
  }), _vm._v("shrug it off or sweep it under the rug."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en57",
      "id": "en57r",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])]), _vm._v(" But, like all stacked decks, segregation has a history, and it does not persist without maintenance. Our tour of Chicago begins by revealing some of the origins of Chicago’s segregated stacked deck and how it manifests and endures in the city’s housing.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig2"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p25"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-bartram-fig002.jpeg",
      "width": "463"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FIGURE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.")])]), _vm._v(" Median household income in Chicago, 2010. Shadings show median household income at the census tract level, with lowest incomes in lighter shades and highest incomes in darker shades. Map by Richard Campanella.")])])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig3"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "26",
      "epub:type": "pagebreak",
      "id": "p26",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-bartram-fig003.jpeg",
      "width": "463"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FIGURE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.")])]), _vm._v(" White population in Chicago, 2012. Shadings show percentage White population at the census tract level, with lower percentages of White residents in lighter shades and higher percentages in darker shades. Map by Richard Campanella.")])])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0102"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "27",
      "epub:type": "pagebreak",
      "id": "p27",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Institutional Neglect on the Southwest Side")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The first stop on the tour is a block of South Loomis Boulevard, in a Southwest Side neighborhood. Many of the buildings on this block are vacant and have accrued handfuls of building code violations over the years. This is an inspector’s report for one house on the block:")]), _vm._v(" "), _c('blockquote', [_c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "bqulf"
  }, [_vm._v("front wall at 2nd open mortar joints")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("repair exterior platform")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("front concrete treads open mortar joints")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("front at exterior door, rear at basement door gaps around door")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("rear at basement wall open mortar joints, buckling")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("1st living room windows don’t hold open")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("all elevations rotten window frames")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("int wall/ceiling peeling paint")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("1st living room, 1st foyer, 2nd floor kitchen walls and ceiling peeling paint and mold at 2nd")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("1st rear kitchen broken pane.")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("int wall/ceiling chip plaster")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("1st kitchen ceiling holes in plaster")]), _vm._v(" "), _c('li', {
    staticClass: "bqul"
  }, [_vm._v("1st kitchen floor torn tiles holes around radiator on floor")])]), _vm._v(" "), _c('p', {
    staticClass: "bqt"
  }, [_vm._v("—Building inspector report for a house on South Loomis Boulevard, 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The mold, holes, and buckling mortar in this report troubled the house on the corner of South Loomis for many years. The owners could not afford to fix them. But the house is empty now, the owners long gone. In place of a welcome mat, an orange Buildings Department sign is pasted on the front door declaring that the vacant building is awaiting demolition. These signs are common in this part of Chicago, but vacancy and demolition are not the only stories that buildings on South Loomis tell. Across the street, a two-flat recently changed ownership. Its previous owner had lived in the building for decades, renting out the second unit to an extended family member (what many Chicagoans call a “family building”). Maintenance issues and unpaid property taxes piled up, however, and the longtime owner had no choice but to sell. The new owner is an investment company based in New Jersey that rents the property out. The company fixed up some severe issues, but did not tend to the yard, which is overgrown and littered. This building and its overgrown yard sit across the street from "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "28",
      "epub:type": "pagebreak",
      "id": "p28",
      "role": "doc-pagebreak"
    }
  }), _vm._v("an empty lot where a single-family home stood until it was demolished recently. Grass and weeds are just starting to grow up through the dirt. Between them, these three addresses have accrued over sixty building violations in ten years, from faulty wiring, rotting wooden siding, and buckling brickwork to unstable porches and roofs, and demolition orders. These are listed online, if you know where to look, as is information on whether issues have been addressed. Most on Loomis have not. They linger online like a building’s version of a criminal record, seeming to speak volumes about the condition of the buildings but nothing about the underlying causes of their deterioration.")]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0101"
    }
  }, [_vm._v("Black Belt, White Flight, and Redlining")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Until the 1960s, this Southwest Side neighborhood was majority White ethnic—mostly first- and second-generation European immigrants. It was close to the area of Chicago known as the “Black Belt,” which was home to most of the city’s Black population—the majority of whom had migrated from the South in the first half of the twentieth century. The Black Belt was getting increasingly crowded, but African Americans had few other options for housing due to pervasive discrimination. Meanwhile, conservative backlash against the New Deal ushered in government programs that demolished what affordable housing was left in the name of slum clearance. Elsewhere in the city, White Chicagoans went to great—and violent—lengths to prevent African Americans from moving beyond the borders of the Black Belt."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en58",
      "id": "en58r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])]), _vm._v(" As in other White neighborhoods, homeowners in this Southwest Side neighborhood used racial covenants that prohibited property owners from selling or renting to African Americans."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en59",
      "id": "en59r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])]), _vm._v(" White Chicagoans also bombed Black homes as part of their campaigns of terror to scare African Americans away from White neighborhoods.")]), _vm._v(" "), _c('p', [_vm._v("But racial demographics did change in many South and West Side Chicago neighborhoods. A combination of racism and panic over institutional neglect and declining property values (stoked by the real estate industry) led to a broad residential shift. This phenomenon of Whites leaving neighborhoods as African Americans moved in is commonly known as “White flight.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en60",
      "id": "en60r",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])]), _vm._v(" The hard-won arrival of the newcomers was costly, in part due to the practice that we now call “redlining,” in which the Federal Housing Administration used maps that marked communities of color as unstable and thus too risky for mortgage insurance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en61",
      "id": "en61r",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])]), _vm._v(" Black families were denied mortgages and were left with few options other than contract sales, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "29",
      "epub:type": "pagebreak",
      "id": "p29",
      "role": "doc-pagebreak"
    }
  }), _vm._v("which—as Beryl Satter details"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en62",
      "id": "en62r",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])]), _vm._v("—promised (but did not guarantee) legal ownership only after years of hefty payments. Black families in Southwest Side neighborhoods—and elsewhere—paid higher monthly payments toward their contract sale than they would have paid on a conventional mortgage. A clear extraction of wealth, these payments amounted to an average 84 percent markup over the life of the contract."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en63",
      "id": "en63r",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])]), _vm._v(" Contract sellers became millionaires."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en64",
      "id": "en64r",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', [_vm._v("Contract sales are one example of the exploitation—on the part of property owners, landlords, and real estate agents—of Black Chicagoans’ lack of residential options. Exploitation also meant that prices actually initially increased in the very neighborhoods that Whites were abandoning for fear of declining property values. Yet the average Black resident did not benefit. Despite the high prices Black residents paid to landlords, their homes frequently had no heat or electricity, but plenty of rodents, rotten wood, and broken pipes. Building owners also modified and carved up buildings to maximize the number of units (and their profits), which created dangerous conditions and serious building code violations. This practice is known as “milking,” and it is one reason why properties in communities of color were often in such bad shape."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en65",
      "id": "en65r",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0102"
    }
  }, [_vm._v("Wealth Extraction")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The government eventually passed laws to abolish redlining and end housing discrimination. But the real estate industry had another racist trick up its sleeve—“predatory inclusion,” a practice that targeted African Americans for loans with additional fees and penalties, high interest, and adjustable rates."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en66",
      "id": "en66r",
      "role": "doc-noteref"
    }
  }, [_vm._v("15")])]), _vm._v(" While the legalese was different, little changed in housing conditions. The homes that realtors marketed and sold to African Americans were often dangerous and just as often squalid."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en67",
      "id": "en67r",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])]), _vm._v(" Yet this did not stop governments from systematically over-assessing properties in communities of color, extracting further wealth from minority homeowners and rendering them more vulnerable to tax delinquency and property liens—legal claims against property that city governments auction off to the highest-bidding investor."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en68",
      "id": "en68r",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])]), _vm._v(" In these ways, city governments enabled investment firms to profit from struggling homeowners like those who used to live on Loomis. Prior extraction of wealth and disinvestment coupled with deindustrialization concentrated poverty on the South and Southwest Sides of Chicago. Like in the South Side Chicago neighborhood that William Julius Wilson made famous,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en69",
      "id": "en69r",
      "role": "doc-noteref"
    }
  }, [_vm._v("18")])]), _vm._v(" jobs around Loomis Boulevard disappeared. In "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "30",
      "epub:type": "pagebreak",
      "id": "p30",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the 1970s, a public transit depot near Loomis closed, adding to the loss of stockyard and railroad jobs. Unemployment rose, and those that could left, taking their tax dollars to other neighborhoods and leaving behind them empty buildings and shuttered businesses.")]), _vm._v(" "), _c('p', [_vm._v("Predatory inclusion ramped up again in the late twentieth and early twenty-first century, after regulatory changes to the way mortgages worked."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en70",
      "id": "en70r",
      "role": "doc-noteref"
    }
  }, [_vm._v("19")])]), _vm._v(" Historically, homeowners had taken out loans from—and then paid them back directly to—a lender. This meant that lenders were careful about who they lent to. In the new system, however, lenders were permitted to sell mortgages to investment banks."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en71",
      "id": "en71r",
      "role": "doc-noteref"
    }
  }, [_vm._v("20")])]), _vm._v(" Lenders stopped caring who could repay and offered (often aggressively) riskier loans. Investment banks preferred subprime loans because they have higher interest rates. As a result, lenders targeted low-income and minority populations, hedging bets that they would default on their loans and increase industry profit margins."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en72",
      "id": "en72r",
      "role": "doc-noteref"
    }
  }, [_vm._v("21")])]), _vm._v(" These risky loans—packaged as complex securities—were sold multiple times throughout the financial system. Home prices soared, and investment banks and financial institutions made huge profits, most of them from exploiting low-income people of color.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0103"
    }
  }, [_vm._v("Foreclosures and Speculation")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As is well known, this bubble burst. The lack of regulation or accountability for rating agencies, the increasing complexities of securitization, and the sheer quantity of subprime loans—originated to feed investors—spread the riskiness of subprime loans throughout the global financial system. When interest rates increased in the mid-2000s and the housing market began to stall, homeowners were left with unaffordable loans. A foreclosure crisis ensued."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en73",
      "id": "en73r",
      "role": "doc-noteref"
    }
  }, [_vm._v("22")])]), _vm._v(" The government bailed out banks and mortgage companies, protecting them from the ill effects of the crash. The same protection was not extended to homeowners like those on South Loomis, which led to the concentration of foreclosures and abandonment, and explains the oft-depicted derelict buildings, vacant homes, and empty lots in many low-income and minority neighborhoods."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en74",
      "id": "en74r",
      "role": "doc-noteref"
    }
  }, [_vm._v("23")])]), _vm._v(" “Poor people had nothing and they took all their shit,” remarked a Southwest Side resident who lives near Loomis Boulevard."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en75",
      "id": "en75r",
      "role": "doc-noteref"
    }
  }, [_vm._v("24")])]), _vm._v(" There are thousands of foreclosed homes on the Southwest Side of Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en76",
      "id": "en76r",
      "role": "doc-noteref"
    }
  }, [_vm._v("25")])]), _vm._v(" And in 2016, between 10 and 25 percent of housing stock was empty on Loomis and the surrounding area."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en77",
      "id": "en77r",
      "role": "doc-noteref"
    }
  }, [_vm._v("26")])]), _vm._v(" The vast majority of neighborhoods with the highest recent rates of foreclosure are majority Black or Latinx."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en78",
      "id": "en78r",
      "role": "doc-noteref"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "31",
      "epub:type": "pagebreak",
      "id": "p31",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Foreclosures are bad news beyond the implications for their foreclosed owners because they exacerbate the deterioration of housing conditions. Banks can sell foreclosed properties at auction or opt out of assuming ownership. The latter often occurs in poor neighborhoods where banks want to avoid responsibility for tax payments and property maintenance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en79",
      "id": "en79r",
      "role": "doc-noteref"
    }
  }, [_vm._v("28")])]), _vm._v(" Predicting sales will be slower and less lucrative in poor neighborhoods, banks allow buildings to become “zombie properties,” where there is no clear owner. “Zombie properties” are properties on which a foreclosure claim has been filed but not resolved within three years. Because neither the lender nor the homeowner has control over the property, both lack clear incentive to invest in the property, pay taxes, or keep up with maintenance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en80",
      "id": "en80r",
      "role": "doc-noteref"
    }
  }, [_vm._v("29")])]), _vm._v(" By leaving properties vacant and unmaintained, banks save money and avoid demolition costs. Zombie properties are disproportionately concentrated in lower-income minority communities that look like Loomis Boulevard."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en81",
      "id": "en81r",
      "role": "doc-noteref"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', [_vm._v("In addition to problems associated with physical dilapidation and increases in insurance premiums for neighboring homeowners, vacant buildings have distinct effects on their surrounding communities. Empty buildings and vacant lots are a moral and reputational force that local elites and outside investors can deploy for financial gain by using them as a focal point to justify new investment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en82",
      "id": "en82r",
      "role": "doc-noteref"
    }
  }, [_vm._v("31")])]), _vm._v(" This problem is amplified because city governments tend to allow the owners of vacant properties a lot of time before they intervene."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en83",
      "id": "en83r",
      "role": "doc-noteref"
    }
  }, [_vm._v("32")])]), _vm._v(" Financial speculation turns vacancies into rent gaps, which are a prerequisite for economic investment and gentrification."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en84",
      "id": "en84r",
      "role": "doc-noteref"
    }
  }, [_vm._v("33")])]), _vm._v(" At financially opportune times, property acquisition companies and investment firms—like the New Jersey investment firm that now owns the two-flat on South Loomis—buy up high volumes of dilapidated buildings, including single-family homes, convert them into rentals, and turn them into real estate assets for private equity and other financial firms."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en85",
      "id": "en85r",
      "role": "doc-noteref"
    }
  }, [_vm._v("34")])]), _vm._v(" The deck is stacked, in other words, by and in favor of these financialized housing market actors."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en86",
      "id": "en86r",
      "role": "doc-noteref"
    }
  }, [_vm._v("35")])]), _vm._v(" These profiteers are part of a broader group called rentiers: people who profit from income derived from assets with a limited supply, such as housing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en87",
      "id": "en87r",
      "role": "doc-noteref"
    }
  }, [_vm._v("36")])]), _vm._v(" In turn, profiteers have stacked the deck against homeowners on South Loomis, and thousands of others in Chicago.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0104"
    }
  }, [_vm._v("Race and Real Estate")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The stacked deck is also steeped in racism. While histories of slavery, racial capitalism, and exploitation created economic disparities between White "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "32",
      "epub:type": "pagebreak",
      "id": "p32",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Americans and others, contemporary housing policies and practices sustain patterns of racial and economic inequality. For example, governments continue to over-assess homes in communities of color. This means that property owners of color pay higher taxes than Whites for comparable homes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en88",
      "id": "en88r",
      "role": "doc-noteref"
    }
  }, [_vm._v("37")])]), _vm._v(" At the same time, the real estate industry consistently undervalues properties in communities of color, making it harder for property owners to build wealth and equity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en89",
      "id": "en89r",
      "role": "doc-noteref"
    }
  }, [_vm._v("38")])]), _vm._v(" The real estate market also includes the people that articulate demand for housing—their individual behaviors play a role in stacking the deck as they buy into it and sort themselves racially. The demands of home buyers—for neighborhoods with good schools and reputations, for instance—contribute to the undervaluing of historically disinvested neighborhoods because they are less likely to have resourced schools or good reputations in comparison to White neighborhoods."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en90",
      "id": "en90r",
      "role": "doc-noteref"
    }
  }, [_vm._v("39")])]), _vm._v(" But realtors also make assumptions about where people want to live and steer White people to White neighborhoods, for example, further cementing segregation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en91",
      "id": "en91r",
      "role": "doc-noteref"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', [_vm._v("The picture has been made bleaker still by banks that consistently deny conventional loans to homeowners in communities of color. Chase Bank recently loaned nearly nine times more in a single majority White neighborhood on Chicago’s North Side than it did in all the city’s majority Black neighborhoods combined."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en92",
      "id": "en92r",
      "role": "doc-noteref"
    }
  }, [_vm._v("41")])]), _vm._v(" Such obvious deck-stacking has severe consequences. Black and Latinx homeowners not only have lower home values; they are also more cost-burdened by their homes"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en93",
      "id": "en93r",
      "role": "doc-noteref"
    }
  }, [_vm._v("42")])]), _vm._v(" and are much more likely to live in substandard housing. Their relative lack of wealth also results in less money for home repairs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en94",
      "id": "en94r",
      "role": "doc-noteref"
    }
  }, [_vm._v("43")])]), _vm._v(" In many cities, unresolved building violations—like the issues in the house on South Loomis—result in property liens, further stacking the deck against owners of color.")]), _vm._v(" "), _c('p', [_vm._v("Much of what South Loomis has experienced are national phenomena—from White flight, redlining, wealth extraction, and foreclosures to the pervasive over-assessing and undervaluing of communities of color. These policies and practices mean that the deck is stacked most overwhelmingly against residents in communities of color across the US. By contrast, banks and many Whites benefited from White flight, investment, positive appraisals, and increasing home values in the neighborhoods in which they live. Both sides of this history have created depressed housing markets on the South and West Sides of Chicago that result in the kind of disrepair, with pockets of speculative investment, found on Loomis Boulevard. History has not only created this material landscape; it has also created a situation in which this area has come to be known and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "33",
      "epub:type": "pagebreak",
      "id": "p33",
      "role": "doc-pagebreak"
    }
  }), _vm._v("recognized in terms of physical features of dilapidation, neglect, and abandonment. This is only one side of the coin, however, in Chicago’s relational stacked deck. We visit another side next on our tour as we travel to Chicago’s North Side.")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0103"
    }
  }, [_vm._v("Concentrated Wealth on the North Side")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("It is hard to miss the disparity if you go directly from Loomis Boulevard to Victoria Street. The trees in the yards on Victoria provide shade for the wicker chairs on the porches of houses, which are set back from the street in a leafy neighborhood by the lake on the North Side of Chicago. A couple—White and in their late fifties—have owned one house on Victoria Street for over twenty years. They paid off their mortgage early, which means they own their house outright and will never face mortgage foreclosure. The couple bought the house for a price equivalent to $86,000 in 2020 dollars. It is now valued at $790,000. The house is a few blocks away from homes that cost double that. To be sure, the house on Victoria Street is not a mansion. Compared to the residents on South Loomis, the owners are wealthy, but my bet is that they do not consider themselves rich. Their wealth is undeniable, but it is also subtle—more about stability and comfort than opulence. This is important because it makes their wealth less noticeable.")]), _vm._v(" "), _c('p', [_vm._v("The house is impeccably maintained. The maintenance, plus a couple of remodeling projects through the years, have added thousands—probably tens of thousands—to the house’s value. Homeowners with access to financial resources have a way of preserving and extending wealth through remodeling, building additions, keeping on top of maintenance, and other actions that add to property values. The house on Victoria is old, and there have been issues over the years that required permits and considerable repair work. But the couple could afford it—in part because of their salaries and in part because of some inheritance. There is no rotting siding or flaking paint.")]), _vm._v(" "), _c('p', [_vm._v("The house on Victoria Street has not avoided building inspections, however. A few years ago, a neighbor called the City to complain about noise from a remodeling project. An inspector came out and found that the project was not permitted—the couple had not gone through official channels to get a permit for the work. As a result, the owners ended up in building court. As they recounted the story, it became clear that this "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "34",
      "epub:type": "pagebreak",
      "id": "p34",
      "role": "doc-pagebreak"
    }
  }), _vm._v("was a headache for them, but did not cause an issue overall. “We went to . . . court and of course, we had to get the permit,” they explained to me. “I mean that’s the rules. . . . That was no big deal.” The owners’ nonchalance about the court case and associated costs reveals a lot about their access to resources. If you search for their property on the City’s online building violation database, you can see that this one violation is listed as “addressed,” suggesting that there are no remaining issues with the building.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("Submit plans prepared, signed, and sealed by a licensed architect or registered structural engineer for approval and obtain permit. "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ADDRESSED")])]), _vm._v(" "), _c('p', {
    staticClass: "bqt"
  }, [_vm._v("—Building inspector report for the house on Victoria Street, 2008")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0105"
    }
  }, [_vm._v("White Wealth")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The couple’s college-aged kids will inherit the house. But the intergenerational wealth that this hundred-year-old house provides is no stroke of luck. While federal policies subsidized White homeownership in the suburbs,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en95",
      "id": "en95r",
      "role": "doc-noteref"
    }
  }, [_vm._v("44")])]), _vm._v(" municipal policies also favored White neighborhoods and benefited White homeowners within cities. Propitious housing policy is one of the main reasons that White families now have nearly ten times more wealth than Black families. Much of the racial disparity in intergenerational wealth in Chicago can be explained by the thirty-plus-percentage point gap between Black and White homeownership."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en96",
      "id": "en96r",
      "role": "doc-noteref"
    }
  }, [_vm._v("45")])]), _vm._v(" Contemporary policies like the mortgage interest deduction program continue to subsidize and reward the most affluent property owners by allowing them to reap higher tax returns the more expensive their property is."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en97",
      "id": "en97r",
      "role": "doc-noteref"
    }
  }, [_vm._v("46")])]), _vm._v(" Wealth begets wealth, especially for homeowners."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en98",
      "id": "en98r",
      "role": "doc-noteref"
    }
  }, [_vm._v("47")])]), _vm._v(" The deck has been stacked in favor of wealthy homeowners and their children.")]), _vm._v(" "), _c('p', [_vm._v("This house on Victoria Street shares a history with thousands of other single-family homes on the North Side of Chicago. Like many others, the neighborhood where this house stands was developed for wealthy Whites in the 1880s and has remained predominantly White to this day. Zoning decisions carved out White neighborhoods for residential use, while designating commerce and industry in and near communities of color."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en99",
      "id": "en99r",
      "role": "doc-noteref"
    }
  }, [_vm._v("48")])]), _vm._v(" Additional spot zoning decisions, annexation, and municipal incorporation also deterred integration, helping to shore up White spaces and White property values."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en100",
      "id": "en100r",
      "role": "doc-noteref"
    }
  }, [_vm._v("49")])]), _vm._v(" Even places on the North Side that were dilapidated and redlined in the mid-twentieth century recovered—due to conservation movements led by White middle-class “rehabbers,” who sought to extend "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "35",
      "epub:type": "pagebreak",
      "id": "p35",
      "role": "doc-pagebreak"
    }
  }), _vm._v("“already-established strongholds of the upper middle class.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en101",
      "id": "en101r",
      "role": "doc-noteref"
    }
  }, [_vm._v("50")])]), _vm._v(" Rehabbing on Chicago’s North Side in the mid-twentieth century was not just about saving old, dilapidated buildings—it had just as much to do with avoiding poverty and growing populations of Black and Latinx residents.")]), _vm._v(" "), _c('p', [_vm._v("Proximity to wealth—and distance from poverty—was also important on Victoria Street. So much so that, in the 1980s, neighborhood property owners persuaded the City to recognize the neighborhood as separate from an adjacent area that was distinctly lower-income and less White, thereby dividing the allocation of resources and changing the neighborhood’s name. This “rebranding” allowed residents and real estate actors to market the neighborhood in a way that increased property values and concentrated wealth, which also led to better-resourced schools and other amenities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en102",
      "id": "en102r",
      "role": "doc-noteref"
    }
  }, [_vm._v("51")])]), _vm._v(" These factors also make the neighborhood more desirable. The home-building industry is tuned into desirability and concentrates new construction in or near White areas. On top of new homes, uneven geographies of new construction mean that new drains, sewers, sidewalks, and amenities tend to be located in White neighborhoods."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en103",
      "id": "en103r",
      "role": "doc-noteref"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', [_vm._v("The concentration of wealth in many contemporary White neighborhoods also makes possible safe, comfortable, and even luxurious housing conditions: from lead abatement, modern HVAC systems, and manicured yards to pools, security systems, high fences, and gated communities. Some of these features—most often found among upper- or middle-class White households—are products of defensiveness and homeowners’ racist perceptions of danger."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en104",
      "id": "en104r",
      "role": "doc-noteref"
    }
  }, [_vm._v("53")])]), _vm._v(" In other words, the condition and aesthetic of White neighborhoods are as much a product of urban policies and historical trends as those in communities of color. Yet the privilege that advantages White neighborhoods is obscured, and instead we are told that White neighborhoods are the default, desirable ideal, and conditions in communities of color need explaining. As Dianne Harris demonstrates, Whiteness and what we think of as “ordinary homes” grew up together. But architecture is not benign, especially when it is “so ordinary we hardly notice it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en105",
      "id": "en105r",
      "role": "doc-noteref"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', [_vm._v("We know a good amount about the construction and co-option of aesthetic preferences of gentrifiers, and that some built environments are marketed as authentic, improvements, or as universally desirable when in fact they are not."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en106",
      "id": "en106r",
      "role": "doc-noteref"
    }
  }, [_vm._v("55")])]), _vm._v(" Yet the built environments of White homeowners—wealthy or not—have received less investigation from urban sociologists. White wealth accumulation is hidden, and we let houses in White neighborhoods be proffered as an ideal to all, despite their origins in discrimination, subsidies, and privilege. Housing conditions on the North Side are "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "36",
      "epub:type": "pagebreak",
      "id": "p36",
      "role": "doc-pagebreak"
    }
  }), _vm._v("a product of decision after decision to prioritize White neighborhoods at the expense of communities of color. White neighborhoods are an integral piece of the stacked deck because local and national governments continue to prioritize their financial interests at the expense of other urban residents, whose neighborhoods and interests they neglect.")]), _vm._v(" "), _c('p', [_vm._v("The stacked deck manifests in Chicago’s geography. Most of the North Side looks different from the South Side and the West Side. The stacked deck creates and manifests as building conditions that are consistent within but widely variable across geographical areas of the city. Their shared histories of distinct treatment have created relatively discrete appearances in different neighborhoods. These material conditions become recognizable and socially significant—they can be read and interpreted. Yet, as the following chapters show, we do not always accurately recognize or interpret material conditions. One reason for this is that the reality is not always black and white, and contradictions and differences exist within neighborhoods, even though their material conditions are powerful symbols of wealth, poverty, and disparity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en107",
      "id": "en107r",
      "role": "doc-noteref"
    }
  }, [_vm._v("56")])]), _vm._v(" There are pockets of wealth, development, and investment on the South Side, for example. One such pocket is the next destination on our tour of Chicago’s housing landscape.")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0104"
    }
  }, [_vm._v("Pockets of Profit on the South Side")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("We go back south for the next stop on our tour. This time, though, we are directly south of Chicago’s downtown, on the lakefront. Like so many others, this neighborhood experienced White flight, redlining, and disinvestment. But reinvestment, in part from a community bank, in the 1970s helped the neighborhood build and maintain a middle-class African American community and avoid institutional disinvestment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en108",
      "id": "en108r",
      "role": "doc-noteref"
    }
  }, [_vm._v("57")])]), _vm._v(" A divide exists in this neighborhood, however, as Natalie Moore and Carlo Rotella describe, between the haves and the have-nots: between the proud owner-occupiers of bungalows, the lower-income tenants of apartment buildings (which house the highest number of housing voucher holders in Chicago), and residents in the strip of lakefront high rises."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en109",
      "id": "en109r",
      "role": "doc-noteref"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0106"
    }
  }, [_vm._v("Luxury Living")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("It feels more like a hotel than a rental property. Views of the lake, twenty-four-hour fitness center, a dog run, a boutique lobby, and a party room "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "37",
      "epub:type": "pagebreak",
      "id": "p37",
      "role": "doc-pagebreak"
    }
  }), _vm._v("with a fully equipped kitchen and bar, as well as doorman service. Lots of rehabbed rental buildings look like this. The uniform urban residential architecture has its origins in the 1980s and 1990s, during which time developers and city governments jumped on the opportunity to renovate old buildings and market them to affluent newcomers who valued the architectural styles and features of old buildings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en110",
      "id": "en110r",
      "role": "doc-noteref"
    }
  }, [_vm._v("59")])]), _vm._v(" This helps to explain the homogeneity of building conditions in apartments constructed and targeted at young professionals,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en111",
      "id": "en111r",
      "role": "doc-noteref"
    }
  }, [_vm._v("60")])]), _vm._v(" and the neighborhoods—often close to cultural amenities and public transit—in which they are located. A building like this thus perhaps makes sense for this neighborhood, where the numbers of PhDs significantly exceed Chicago’s averages;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en112",
      "id": "en112r",
      "role": "doc-noteref"
    }
  }, [_vm._v("61")])]), _vm._v(" developers of the lakefront high rise in South Shore likely had in mind upwardly mobile, middle-class, educated renters. But the number of neighborhood residents who did not complete high school also exceeds the city average."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en113",
      "id": "en113r",
      "role": "doc-noteref"
    }
  }, [_vm._v("62")])]), _vm._v(" And the building only recently became a luxury apartment building. Ten years ago, it looked quite different, as this building violation record attests:")]), _vm._v(" "), _c('blockquote', [_c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "bqnlf"
  }, [_vm._v("1. exterior wall repair")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("2. north elevation immense structural wall damage window head cracking many pieces are temporally stabilized dangerous and hazardous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("3. north elevation stone portion of facade spalling, damaged, structural cracks, pieces missing dangerous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("4. northwest corner structural damage at brick wire meshed in place temperately dangerous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("5. northwest corner parapet wall stone pieces have shifted, loose dangerous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("6. all elevations severe washed out mortar, spalling brick, spalling concrete pieces loose dangerous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("7. all elevations steel shelf angles rusting causing severe damage to surrounding brick and masonry")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("8. all elevations steel lintels rusting causing damage to surrounding masonry")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("9. west elevation severe facade damage window headers severely structural damage many temporary stabilized with wire mesh dangerous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("10. west elevation old balconies temporary stabilized, makeshift enclosers many pieces loose, damaged, balconies originally open now enclosed and added as part of units. does not weight code loads")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("11. south elevation spalling concrete, damaged brick, areas wire meshed temporary dangerous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("12. south elevation window heads damaged cracking dangerous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "38",
      "epub:type": "pagebreak",
      "id": "p38",
      "role": "doc-pagebreak"
    }
  }), _vm._v("13. east elevation severe structural facade damage window headers cracking loose, some pieces are temporally stabilized dangerous")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("14. east elevation old balconies temporary stabilized, makeshift enclosers, many pieces loose, damaged, balconies originally open now enclosed and added as part of units. do not meet city weight code loads")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("15. canopies required at north elevation")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("16. penthouse lintels rusted, brick damaged, cracking, severe washed out mortar")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("17. many unit water infiltration causing damage to interior of units by facade deterioration units")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("18. plans and permits for all repairs")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("19. all elevations windows rotted / rusted")])]), _vm._v(" "), _c('p', {
    staticClass: "bqt"
  }, [_vm._v("—Building inspector report for South Shore Drive high rise, 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The high rise clearly had issues—severe structural damage, dangerously cracked exterior walls, precarious balconies, leaks, and rotten and rusted windows. But despite these problems, there was profit to be made from this building. Let’s begin, though, by taking a step back to understand how things got so bad.")]), _vm._v(" "), _c('p', [_vm._v("The South Shore Drive high rise was built in the late 1920s and operated as rental apartments until it was converted to condos in the early 1970s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en114",
      "id": "en114r",
      "role": "doc-noteref"
    }
  }, [_vm._v("63")])]), _vm._v(" Condos are different from rental buildings because people own individual apartment units. Owners pay homeowners’ association fees every month to cover costs of things like building maintenance and water. And a condo association, comprising a group of condo owners, is responsible for distributing the money to cover monthly expenses and other costs that arise. By 2015, the South Shore Drive high rise was in a sorry state. A broken boiler and frozen pipes meant heat was not working, and residents were using their stoves for heat in the harsh Chicago winter. Ceilings were leaking, windows rotting, and masonry crumbling—especially problematic for a sixteen-story building. In court, an inspector testified that the building was a fire hazard because of issues with the gas pipes. But the condo association could not afford to make repairs. Half the units were empty, meaning the association was only collecting 50 percent of assessments. In addition, owners were suddenly responsible for paying a large fee due to a “special assessment” for necessary upkeep of the huge, almost hundred-year-old property. Condo owners who were able to sell were forced to settle for low prices. In 2014 one of these condos sold for $23,000. The owner had purchased it in 1979 for $43,000.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0107"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "39",
      "epub:type": "pagebreak",
      "id": "p39",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Condo Fraud and Deconversions")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Condos have been making the news. During the housing bubble, fraudsters converted rental apartment buildings into owner-occupied condos. But they did so only on paper, and not in reality. Building owners, appraisers, lenders, and straw buyers"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en115",
      "id": "en115r",
      "role": "doc-noteref"
    }
  }, [_vm._v("64")])]), _vm._v(" worked in cahoots to secure financing and advertise and sell condo units that did not exist or were already inhabited. Then they fled with the money."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en116",
      "id": "en116r",
      "role": "doc-noteref"
    }
  }, [_vm._v("65")])]), _vm._v(" Sometimes entire buildings were invented. In one case, the FBI indicted Chicago real estate investors and loan originators for their role in fraudulently obtaining mortgages totaling $8.5 million."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en117",
      "id": "en117r",
      "role": "doc-noteref"
    }
  }, [_vm._v("66")])]), _vm._v(" In other instances, management companies and other signatories of condo associations committed fraud by collecting—and then pocketing—assessments and fees, leaving condo associations without the funds for maintenance and emergency repairs.")]), _vm._v(" "), _c('p', [_vm._v("In Illinois, as elsewhere, fraud prompted new legislation to mandate that condo buildings be “deconverted” to rental buildings to make buying and selling the buildings more feasible."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en118",
      "id": "en118r",
      "role": "doc-noteref"
    }
  }, [_vm._v("67")])]), _vm._v(" After the declaration of deconversion, the City files a separate motion asking for the property to be sold, oftentimes to an entity called a receiver. Receivership is a broad city initiative in which a building court judge appoints a third party to fix building code violations if the owner is not able or willing to do so. To ensure payment, the receiver records liens against the properties. Liens stipulate that the receiver can take possession of the property until the debt for repair work is paid. Thus, when owners do not pay, receivers foreclose, take possession, and sell buildings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en119",
      "id": "en119r",
      "role": "doc-noteref"
    }
  }, [_vm._v("68")])]), _vm._v(" Though private receivership occurs, receivers in Chicago are usually public-private entities, funded by banks and subdivisions of the Treasury Department."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en120",
      "id": "en120r",
      "role": "doc-noteref"
    }
  }, [_vm._v("69")])]), _vm._v(" Receivership most often occurs in multi-unit buildings on the South and West Sides of the city, with some in the far North and Northwest."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en121",
      "id": "en121r",
      "role": "doc-noteref"
    }
  }, [_vm._v("70")])]), _vm._v(" While receivership ensures that repairs get made to buildings inspectors deem dangerous, it also enables profit by exploiting rent gaps in lucrative areas. In this way, receivership can amount to government-sponsored flipping.")])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0108"
    }
  }, [_vm._v("Matching Profit Strategies to Markets")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("A building court judge appointed a receiver for the South Shore Drive high rise in 2015, after the building had been in building court—as a result of its long list of building code violations—for over twelve years. All other options were exhausted: the condo board was bankrupt, and no one had "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "40",
      "epub:type": "pagebreak",
      "id": "p40",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the money to address all the repairs that were necessary. Condo owners in a different neighborhood might have been able to bounce back from the housing crash, but this would have required more wealth in reserve than South Shore residents typically have, relative to their counterparts in majority White neighborhoods."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en122",
      "id": "en122r",
      "role": "doc-noteref"
    }
  }, [_vm._v("71")])]), _vm._v(" The receiver fixed up the building’s exterior, removing imminent danger from falling bricks and balconies, and the $14 million rehab project was underway.")]), _vm._v(" "), _c('p', [_vm._v("As soon as the initial work was completed, a transnational company snapped up the lakefront high rise. The company specializes in the acquisition, development, and management of rental buildings, and they own over 5,000 apartment units in the Midwest. While their profit margins are not publicly available data, this kind of landlordism is big business with an increasing presence in Chicago’s rental market. At this writing, one out of every four homes sold in the Chicago area was going to investment buyers (i.e., owners who do not live in the property)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en123",
      "id": "en123r",
      "role": "doc-noteref"
    }
  }, [_vm._v("72")])]), _vm._v(" Whether they are buying up foreclosed single-family homes in bulk as portfolio or multi-unit buildings, these corporate landlords share a focus on maximizing returns for their investors."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en124",
      "id": "en124r",
      "role": "doc-noteref"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', [_vm._v("While replacing much of the plumbing and the boiler, the rehab project also converted the South Shore Drive high rise from forty-nine units to over one hundred rental units. After this work was done, a 428-square-foot studio unit rented for $1,249 per month and a 1,034-square-foot “penthouse” cost $3,500. Meanwhile, the median rent in Chicago was $1,077."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en125",
      "id": "en125r",
      "role": "doc-noteref"
    }
  }, [_vm._v("74")])]), _vm._v(" The average unit in the building is 850 square feet. It has become common practice to downsize unit square footage and include luxury amenities to rent properties at prices that are high for the area, with wide profit margins for investors and developers. The justification for the uptick in such small units is the provision of affordable housing, contemporary trends toward small households, and matching tastes of the young urban professionals who value location over unit size. But the high rents of many of these units—including those in the South Shore high rise—suggest that they are an efficient way to make money rather than a source of affordable housing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en126",
      "id": "en126r",
      "role": "doc-noteref"
    }
  }, [_vm._v("75")])]), _vm._v(" It is no accident that units in newly rehabbed buildings across the city—and the nation—look similar. Size and style are products—as they always have been—of money-making strategies.")]), _vm._v(" "), _c('p', [_vm._v("However, strategies for maximizing profit depend on local context."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en127",
      "id": "en127r",
      "role": "doc-noteref"
    }
  }, [_vm._v("76")])]), _vm._v(" In buildings like the lakefront high rise, property flippers and rehabbers try to make a quick profit by successfully predicting market appreciation in certain areas."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en128",
      "id": "en128r",
      "role": "doc-noteref"
    }
  }, [_vm._v("77")])]), _vm._v(" The luxury aesthetic and condition of the lakefront high "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "41",
      "epub:type": "pagebreak",
      "id": "p41",
      "role": "doc-pagebreak"
    }
  }), _vm._v("rise is due in no small part to the fact that the surrounding area is coveted: it is by the lakefront, close to downtown and historic South Side neighborhoods, and near the site of the future Obama Presidential Center. In relatively strong housing markets like this one, landlords tend to upgrade properties: renovating, flipping, and raising rents. In weaker markets, landlords take aim at the low-rent sector of the market by intentionally under-maintaining properties while still increasing rents to exploit low-income populations with limited options. Landlords buy buildings but do little to improve them. Renting out substandard and dilapidated units can still turn high profits."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en129",
      "id": "en129r",
      "role": "doc-noteref"
    }
  }, [_vm._v("78")])]), _vm._v(" While some landlords cannot afford maintenance,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en130",
      "id": "en130r",
      "role": "doc-noteref"
    }
  }, [_vm._v("79")])]), _vm._v(" others—sometimes referred to as “milkers”—buy up cheap properties and intentionally spend as little as possible on rehabilitation and maintenance while maximizing rents.")]), _vm._v(" "), _c('p', [_vm._v("Early work on slumlords, and the government’s failure to prevent them, suggests that there is little profit to be made in slum housing, therefore owners are not economically capable of maintaining buildings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en131",
      "id": "en131r",
      "role": "doc-noteref"
    }
  }, [_vm._v("80")])]), _vm._v(" In fact, scholars suggested that the widespread assumption about profit and willful negligence is the reason that slumlordism continues: the negative reputation prevents the government from assisting slumlords in making improvements. Recent studies, however, show that government policy encourages and enables huge profits from poorly maintained rental housing, a trend that is particularly prominent among professional and non-local landlords."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en132",
      "id": "en132r",
      "role": "doc-noteref"
    }
  }, [_vm._v("81")])]), _vm._v(" In strong "), _c('i', [_vm._v("and")]), _vm._v(" weak housing markets, landlords find ways to make profits for their investors, doing their best to ensure that the deck is stacked in their favor whatever the context. Landlords’ actions vary across markets, but they share the capacity to produce physical conditions. As such, buildings in neighborhoods—or pockets of neighborhoods—with strong housing markets tend to look one way, and those in weak markets look another.")]), _vm._v(" "), _c('p', [_vm._v("Subsidized housing has some particular aesthetics too. The South Shore Drive high rise stands among apartment buildings that are home to the highest number of housing voucher holders in the city. Housing vouchers are one piece of federal housing policy. The demolition of public housing and other policy decisions have created a market in which private entities can profit—often through tax incentives or the guarantee of rent dollars from the housing choice voucher program (commonly known as Section 8)—from the provision of subsidized affordable housing units."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en133",
      "id": "en133r",
      "role": "doc-noteref"
    }
  }, [_vm._v("82")])]), _vm._v(" Landlords that rent to voucher holders also play their part in creating specific housing conditions. As Eva Rosen describes, landlords sometimes "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "42",
      "epub:type": "pagebreak",
      "id": "p42",
      "role": "doc-pagebreak"
    }
  }), _vm._v("add additional layers of drywall to cover lead paint, decreasing square footage, because they know housing inspectors look for lead paint in units rented to voucher holders."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en134",
      "id": "en134r",
      "role": "doc-noteref"
    }
  }, [_vm._v("83")])]), _vm._v(" During renovations, housing choice voucher landlords remove second bathrooms, windows, and basement access so that tenants have fewer toilets to clog, windows to break, and space to inhabit. Landlords’ assumptions about voucher holders’ behavior shapes the material conditions of their housing. As such, though voucher holders rent in the private rental market, the units available to them may not look like an average rental unit, and certainly do not resemble the upmarket rentals in the South Shore Drive high rise. Here, as in many other places, disparity is as evident within the neighborhood as in comparison with others.")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0105"
    }
  }, [_vm._v("Displacement on the Northwest Side")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Next on the tour, we travel to Wellington Street, in a neighborhood on the city’s Northwest Side. Historically, this has been a first destination for immigrants and refugees, who settle in the neighborhood before moving to the suburbs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en135",
      "id": "en135r",
      "role": "doc-noteref"
    }
  }, [_vm._v("84")])]), _vm._v(" Over time, the neighborhood’s housing stock of apartment buildings and two- and three-flats constructed in the early 1900s has been home to large populations of Jews, Koreans and Filipinos, and Mexicans. Neighborhood organizations believe the housing stock is one reason the neighborhood was so popular with working-class immigrants: the three- or four-bedroom flats include a living room that can be converted into an extra bedroom, making the neighborhood ideal for cohabitation or doubling up to save on rent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en136",
      "id": "en136r",
      "role": "doc-noteref"
    }
  }, [_vm._v("85")])]), _vm._v(" In the 1970s these aging buildings caught the attention of city planners, who designated parts of the neighborhood as “blighted” and prime candidates for urban renewal. Residents and community organizations stopped this from happening, and the area remained largely untouched by city planners or developers. Instead, the government and local development corporations joined forces to fix up dilapidated buildings and offer low-interest loans."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en137",
      "id": "en137r",
      "role": "doc-noteref"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', [_vm._v("Now the Northwest Side neighborhood is at the forefront of political conflict over gentrification in the city. It is close to public transit and abuts other popular neighborhoods that have become increasingly expensive. While the term “gentrification” is used by activists, residents, community organizations, and the media, its definition has been notoriously hard to pin down. This is in no small part due to competing images of gentrification. Some see gentrification as a nearly unstoppable force that "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "43",
      "epub:type": "pagebreak",
      "id": "p43",
      "role": "doc-pagebreak"
    }
  }), _vm._v("entails displacement and drastically determines residential patterns in cities. Others are more hesitant, and see gradation in the neighborhood changes included under the umbrella label of gentrification."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en138",
      "id": "en138r",
      "role": "doc-noteref"
    }
  }, [_vm._v("87")])]), _vm._v(" Unstoppable or not, things have changed in the neighborhood. Condos have become more common. Rental buildings are increasingly owned by limited-liability corporations (LLCs), which means owners are protected from personal financial risk and thus have less incentive to provide decent housing or to follow the letter of the law in managing property. LLCs became available in the 1990s, and their presence in the Northwest Side neighborhood has coincided with intimidation tactics to displace tenants, and increased rents."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en139",
      "id": "en139r",
      "role": "doc-noteref"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0109"
    }
  }, [_vm._v("Tools of Displacement")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Targeted inspections of buildings that have been identified as problematic—usually for alleged drug and gang activity—are another tool of displacement."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en140",
      "id": "en140r",
      "role": "doc-noteref"
    }
  }, [_vm._v("89")])]), _vm._v(" These kinds of inspections happen in cities across the country. In Chicago, they are called Strategic Task Force (STF) inspections."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en141",
      "id": "en141r",
      "role": "doc-noteref"
    }
  }, [_vm._v("90")])]), _vm._v(" Spurred by a request from the police department, a task force enters (forcibly if necessary) a property linked to criminal activity. The task force—comprising a team of building and fire inspectors, chaperoned by the police—combs through the building under instructions to cite the owner for every possible violation of building and fire codes. There were 5,705 STF inspections between 2006 and 2015. The aim of these inspections is to cite property owners for as many violations as possible, send the building to court, and pressure the owner to evict tenants deemed problematic. Crackdowns on so-called problem buildings are part of community policing programs in cities nationwide, which, due to race- and class-based biases about disorderly behavior, tend to disproportionately penalize minority residents and regulate minority neighborhoods by enforcing behavior that is acceptable to White middle-class moral standards and removing “problematic” minority residents."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en142",
      "id": "en142r",
      "role": "doc-noteref"
    }
  }, [_vm._v("91")])]), _vm._v(" Indeed, as the map in appendix C shows, STF inspections are concentrated on the South and West Sides of Chicago—areas of the city in which communities of color are most concentrated.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("Front exterior entry door—deadbolt lock missing [building unsecured]. Front interior stairway with unsanitary carpeting, graffiti on walls, and trash on stairs. Front doors do not lock, and homeless people sleeping in hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "bqt"
  }, [_vm._v("—Building inspector report for Wellington Street four-flat, 2019")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "44",
      "epub:type": "pagebreak",
      "id": "p44",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The above building code citation is just one of the twenty-three different entries a building inspector reported during an STF inspection of a four-unit building on Wellington Street, in this Northwest Side neighborhood. Other violations in this building include broken windows, missing smoke detectors, kicked-in doors, faulty wiring, and insufficient plumbing. Community members and the police had implicated tenants in this Wellington Street four-flat in a series of shootings and drug dealing on the block."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en143",
      "id": "en143r",
      "role": "doc-noteref"
    }
  }, [_vm._v("92")])]), _vm._v(" The ensuing STF inspection prompted a court case that forced the property owner to either evict the “problematic” tenants and fix up the building or sell it. STF-induced evictions are just one form of displacement, however.")]), _vm._v(" "), _c('p', [_vm._v("A few blocks down Wellington Street sits a red brick six-flat with a host of issues. Exposed wires in the hallways and basement. No smoke detectors. A porch that had partially fallen. Mouse droppings. The tenants had called the City to report these issues. And it was their right to do so—these are violations of the city’s building code, and legislation requires Chicago landlords to make these repairs and to provide smoke alarms."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en144",
      "id": "en144r",
      "role": "doc-noteref"
    }
  }, [_vm._v("93")])]), _vm._v(" But their building owner had done nothing. The tenants were hopeful when this inattentive owner sold the property. But the new owner also failed to deal with the issues. Rather than addressing the tenants’ concerns, the new owner gave the tenants a thirty-day notice to move out. The tenants suspected that their eviction was retaliation for their complaints, which is an illegal, but common, practice."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en145",
      "id": "en145r",
      "role": "doc-noteref"
    }
  }, [_vm._v("94")])]), _vm._v(" With the help of a community organization, the tenants organized a rent strike. Again, the tenants were within their rights; tenants can legally withhold rent if repairs are not done."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en146",
      "id": "en146r",
      "role": "doc-noteref"
    }
  }, [_vm._v("95")])]), _vm._v(" Some safeguards exist for tenants in Chicago, and a handful of organizations offer tenants advice and legal assistance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en147",
      "id": "en147r",
      "role": "doc-noteref"
    }
  }, [_vm._v("96")])]), _vm._v(" Yet the lack of rent control, horror stories about subpar housing conditions, and the proliferation of evictions in the face of increasingly profit-driven corporatization of the rental market mean that the deck is stacked against tenants despite extant protections."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en148",
      "id": "en148r",
      "role": "doc-noteref"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', [_vm._v("Condos that replace rental units on Wellington Street and the surrounding neighborhood lack the luxury of the lakefront high rise we visited on the South Shore, but they boast many more amenities and features than their rental predecessors: in-unit washers, dryers, and dishwashers; colored tile backsplash in kitchens; dark stained hardwood floors; and quartz countertops. Their exteriors are unchanged, aside from fixed up masonry and porches. But these are old buildings, whose age and historic character likely appeal to the upwardly mobile urban professionals moving into the "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "45",
      "epub:type": "pagebreak",
      "id": "p45",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Northwest Side, just as historic architecture does to middle-class residents in Chicago and other US cities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en149",
      "id": "en149r",
      "role": "doc-noteref"
    }
  }, [_vm._v("98")])]), _vm._v(" Aesthetic preferences and architectural choices made by developers structure the look and feel of middle-class housing in contemporary cities. And this has implications for affordable housing, stacking the deck against lower-income renters. Small properties like these have historically been a source of affordable rental housing. Now they are the only housing type in decline in Chicago as, in tight markets like this one, building owners and developers gut the interiors to build condos."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en150",
      "id": "en150r",
      "role": "doc-noteref"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', [_vm._v("The tenants from Wellington Street were some of the 200—mostly Latinx—families displaced from their homes in one three-square-mile area on the Northwest Side of Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en151",
      "id": "en151r",
      "role": "doc-noteref"
    }
  }, [_vm._v("100")])]), _vm._v(" Evictions happen for a variety of reasons—because landlords want to rehab buildings and raise rents and because tenants miss rent payments. But, across the board, evictions reproduce poverty by rendering previously evicted tenants more likely to live in substandard housing and making it harder for them to access housing because landlords screen for previous evictions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en152",
      "id": "en152r",
      "role": "doc-noteref"
    }
  }, [_vm._v("101")])]), _vm._v(" Mirroring nationwide patterns, renters in minority neighborhoods are far more likely to face eviction than in Whiter areas of Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en153",
      "id": "en153r",
      "role": "doc-noteref"
    }
  }, [_vm._v("102")])])])]), _vm._v(" "), _c('section', [_c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bh0110"
    }
  }, [_vm._v("Demise of Affordable Housing")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Affordable housing is not just an issue for people with low incomes, and it does not refer only to government-subsidized housing. Housing is affordable if it costs someone less than 30 percent of their income. Affordable housing is increasingly hard to come by for middle-class residents in contemporary cities. Their limited choices also further constrain the choices of their lower-income counterparts. While some people argue that building more market-rate housing will naturally lead to a filtering process whereby some housing will be available at affordable rates, this does not work in tight markets in part because of middle-class preferences for older housing. In fact, areas like the Northwest Side are more prone to “reverse filtering,” in which middle-class renters crowd out affordable housing, resulting in fewer affordable units for low-income renters."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en154",
      "id": "en154r",
      "role": "doc-noteref"
    }
  }, [_vm._v("103")])]), _vm._v(" Adding to this are unregulated rent increases and stagnant wages, which have created a dearth of affordable housing in many US cities.")]), _vm._v(" "), _c('p', [_vm._v("Although housing has become increasingly unaffordable across the board, renters of color facing discrimination and citizens with criminal records have the fewest options, and the fewest resources to avoid exploitation "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "46",
      "epub:type": "pagebreak",
      "id": "p46",
      "role": "doc-pagebreak"
    }
  }), _vm._v("in the rental market, and are at most risk from housing precarity. As in many other US metro areas, Black and Latinx residents in Chicago are more likely than Whites to a) be renters; b) live in substandard conditions; and c) be cost-burdened by their rental units."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en155",
      "id": "en155r",
      "role": "doc-noteref"
    }
  }, [_vm._v("104")])]), _vm._v(" Black residents are more likely to have criminal records—which landlords can legally use to deny rental applications. As such, the repercussions of increased rents are more likely to affect Black and Latinx renters, who have on average the least financial resources and whose housing access is more constrained than other groups due to the aforementioned issues. Black and Latinx renters are most likely to move into buildings with substandard conditions that receive violations in the first place,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en156",
      "id": "en156r",
      "role": "doc-noteref"
    }
  }, [_vm._v("105")])]), _vm._v(" even if landlords follow the rules by communicating information about code violations before tenants sign a lease."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en157",
      "id": "en157r",
      "role": "doc-noteref"
    }
  }, [_vm._v("106")])]), _vm._v(" While some of the tenants evicted from the Wellington Street area were priced out of the Northwest Side neighborhood and moved away from the place they had called home for over a decade, others reported that they moved into nearby buildings that were in worse condition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en158",
      "id": "en158r",
      "role": "doc-noteref"
    }
  }, [_vm._v("107")])])]), _vm._v(" "), _c('p', [_vm._v("Tenants in the low-income rental market have fewer options, so there is less impetus for landlords to maintain buildings to keep tenants happy. The deck is most stacked against low-income minority renters and, oftentimes, in favor of those who house them. The deck is stacked heavily in favor of rentiers: those who derive income from the ownership, possession, or control of property under conditions of limited or no competition."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chibartram0018#en159",
      "id": "en159r",
      "role": "doc-noteref"
    }
  }, [_vm._v("108")])]), _vm._v(" The way the deck is stacked creates distinct building conditions in different housing markets, and in different parts of the city. These are recognizable and enable categorizations of the city, whereby we can drive past a building that looks a certain way and glean something about who lives there.")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0106"
    }
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The tour of Chicago’s stacked deck has explained why, on average, buildings are in worse shape on the city’s South and West Sides. This is especially the case for properties that house low-income renters or homeowners who were targeted for risky mortgages. By contrast, more money is spent on housing and its upkeep on the North Side. The stacked deck creates clear groups of building conditions in different parts of the city. Some aspects of this tour are particular to Chicago, and others depict more general urban processes. Rather than pick apart what is specific and what is "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "47",
      "epub:type": "pagebreak",
      "id": "p47",
      "role": "doc-pagebreak"
    }
  }), _vm._v("general, the tour of the stacked deck reveals how policies and practices are reified in built form.")]), _vm._v(" "), _c('p', [_vm._v("The stacked deck creates a legible landscape of disparate housing conditions. We see dilapidation or luxury, and we tend to classify places and people in these terms too. Buildings—and their physical condition—serve as signals that guide our evaluations of people and places. Relatively discrete appearances of different neighborhoods become recognizable, and therefore socially significant; they can be read and used to infer a great deal about who lives there, who belongs, who should avoid a neighborhood, and how the deck is stacked. Building inspectors work within this stacked deck. They drive down streets that span the city, take shortcuts, make wrong turns, get lost, and have to retrace their steps. They get called to buildings in total disrepair as well as to new luxury properties. They see it all. And they use the stacked deck as a categorizing schema to inform their opinions and decisions about who deserves leniency or punishment.")]), _vm._v(" "), _c('p', [_vm._v("In the next chapter, we find out more about how this city of stacked decks motivates building inspectors to make surprising decisions. We learn about the importance of their residential backgrounds, their informal training, their awareness of and involvement in headline-making scandals, their on-the-job discretion, and their encounters with the gamut of wealth and poverty. But their decisions about building code violations and housing conditions present us with a puzzle. Their assessment of people and property only partially aligns with the reality of housing inequality.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122020a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-bartram-0008.vue
// module id = 75
// module chunks = 0